import React from 'react';
import { Link } from 'react-router-dom';
import { EngagementSummary } from '../../models/dto/engagement';

export default function EngagementsPage(props: Props) {
	return (
		<React.Fragment>
			<div className="page-container">
				<h1 className="text-center h1-mb-1">Choose an engagement</h1>
				<div className="boxed-list__container">
					{props.engagements.map(e => (
						<div key={e.id} className="boxed-list__item">
							<Link to={`/engagements/${e.id}`}>{e.name || 'Unknown'}</Link> for {e.accountName || 'Unknown'}, created on {e.createdAt ? new Date(e.createdAt).toLocaleString() : 'Unknown'}{e.complete && ' (Complete)'}
						</div>
					))}
					
					{props.engagements.length === 0 &&
						<div className="boxed-list__item boxed-item__item_empty">
							No engagements
						</div>
					}
				</div>
			</div>
		</React.Fragment>
	)
}

interface Props {
	engagements: EngagementSummary[];
}